import { Injectable } from '@angular/core';
import { KEYS_WEB_STORAGE } from 'src/app/commons/util/emun';

import { IDataUser } from 'src/app/commons/models/data-user';
import { SessionStorageService } from './storage/storage.service';

@Injectable({
	providedIn: 'root'
})
export class DataUserService {
	constructor(private _sessionStorageService: SessionStorageService) { }

	getId(): number | null {
		const dataUser = this._sessionStorageService.getItem<IDataUser>(KEYS_WEB_STORAGE.DATA_USER);

		if (dataUser !== null) {
			return dataUser.id;
		}
		return null;
	}

	getFullName(): string | null {
		const dataUser = this._sessionStorageService.getItem<IDataUser>(KEYS_WEB_STORAGE.DATA_USER);

		if (dataUser !== null) {
			return dataUser.fullName;
		}
		return null;
	}

	getPasswordChangeStatus(estado?: boolean): boolean | null {
		const dataUser = this._sessionStorageService.getItem<IDataUser>(KEYS_WEB_STORAGE.DATA_USER);
		if (dataUser !== null) {
			return dataUser.changePassword;
		}
		return null;
	}

	hideAdministratorOptions(): boolean | null {
		if (!this.hideProfileOption() || !this.hideUserOption() ) {
			return false;
		}
		return true;
	}

	hideProfileOption(): boolean | null {
		const dataUser = this._sessionStorageService.getItem<IDataUser>(KEYS_WEB_STORAGE.DATA_USER);

		const foundPrivilege = dataUser.privileges.find(privilege => privilege.option === "PERFILES");

		if (foundPrivilege.state === true) {
			return false;
		}
		return true;
	}

	hideUserOption(): boolean | null {
		const dataUser = this._sessionStorageService.getItem<IDataUser>(KEYS_WEB_STORAGE.DATA_USER);

		const foundPrivilege = dataUser.privileges.find(privilege => privilege.option === "USUARIOS");

		if (foundPrivilege.state === true) {
			return false;
		}
		return true;
	}


}